import {
  ShieldCheck,
  SlidersHorizontal,
  LayoutDashboard,
  Building2,
  Landmark,
  ArrowLeftRight,
  Workflow,
  Wallet,
  BookOpen,
  Terminal,
  FileCode2,
  Code,
  Smartphone,
  Server,
  Boxes,
  UserCheck,
  Filter,
  Gauge,
  Users,
  ScrollText,
  LifeBuoy,
  Cloud,
  CloudOff,
  Lock,
  Blocks,
  Network,
  BadgeCheck,
  Award,
  GitBranch,
  FileSignature,
  Sparkles,
  Coins,
  type LucideIcon,
} from 'lucide-react';

/** Maps the string icon keys used in content data to lucide components. */
export const ICONS: Record<string, LucideIcon> = {
  shield: ShieldCheck,
  policy: SlidersHorizontal,
  platform: LayoutDashboard,
  enterprise: Building2,
  treasury: Landmark,
  payments: ArrowLeftRight,
  defi: Workflow,
  waas: Wallet,
  docs: BookOpen,
  api: Terminal,
  contracts: FileCode2,
  github: Code,
  device: Smartphone,
  server: Server,
  box: Boxes,
  approvals: UserCheck,
  scope: Filter,
  limits: Gauge,
  roles: Users,
  audit: ScrollText,
  support: LifeBuoy,
  cloud: Cloud,
  cloudoff: CloudOff,
  lock: Lock,
  builder: Blocks,
  crosschain: Network,
  verified: BadgeCheck,
  cert: Award,
  opensource: GitBranch,
  signing: FileSignature,
  sparkles: Sparkles,
  coins: Coins,
};

export function getIcon(name: string): LucideIcon {
  return ICONS[name] ?? ShieldCheck;
}
